/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Llama(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/llama.glb')
  const { actions } = useAnimations(animations, group)
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Root_Scene">
        <group name="RootNode">
          <group name="Armature" rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <primitive object={nodes.root} />
          </group>
          <group name="Llama" rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <skinnedMesh
              name="Llama_1"
              geometry={nodes.Llama_1.geometry}
              material={materials.Brown}
              skeleton={nodes.Llama_1.skeleton}
            />
            <skinnedMesh
              name="Llama_2"
              geometry={nodes.Llama_2.geometry}
              material={materials.White}
              skeleton={nodes.Llama_2.skeleton}
            />
            <skinnedMesh
              name="Llama_3"
              geometry={nodes.Llama_3.geometry}
              material={materials.Grey}
              skeleton={nodes.Llama_3.skeleton}
            />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/llama.glb')